// extracted by mini-css-extract-plugin
module.exports = {"successPage":"results_successPage__Aq__B"};